import React, { useEffect, useState } from "react";
import { PortalListingProperties } from "../../../types/portalListing.type";
import { ListingProperties, PortalListingResultDto } from "../../../types/listing.type";
import { httpRequest } from "../../../helpers/api";
import { BaseResponseProps } from "../../../types/config.type";
import { Divider, Space, Tag, Tooltip, Typography } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import NotSet from "../../../components/NotSet";
import PortalSyncLogModal from "./PortalSyncLogModal";
import { LAMUDI_ID } from "../../employee/constant";

interface IProps {
	portLists: PortalListingProperties[];
	listing: ListingProperties;
}
export default function PortalSyncResult({ portLists, listing }: IProps) {
	const [syncResults, setSyncResults] = useState<PortalListingResultDto[]>([]);
	const [showLog, setShowLog] = useState(false);
	const [selectedPortalId, setSelectedPortalId] = useState<string | undefined>();

	useEffect(() => {
		(async () => {
			try {
				let results = [];
				for (const portalListing of portLists) {
					const { data } = await httpRequest.get<BaseResponseProps<PortalListingResultDto>>(
						"/portal-listings/" + portalListing.portalListingId + "/current-result"
					);
					results.push(data.payload);
				}

				setSyncResults(results);
			} catch (err: any) {
				// showErrorMessage(err, false);
			}
		})();
	}, []);

	const showLinkPortal = (id: string) => {
		const syncDetail = syncResults.find((v) => v.portalListingId === id);
		const portListDetail = portLists.find((v) => v.portalListingId === id);

		return portListDetail?.portalAgent?.portal?.portalName === "Lamudi"
			? syncDetail?.message
			: `Link: ${syncDetail?.link || "Not-Set"}`;
	};
	return (
		<>
			<Space
				size={4}
				direction="vertical"
			>
				{portLists.map((v) => (
					<>
						<Space direction="vertical">
							<Tag
								key={v.portalListingId}
								color={v.portalAgent?.portal?.portalName === "Lamudi" ? "warning" : "blue"}
							>
								<Space size={4}>
									{v.portalAgent?.portal?.portalName}
									{(v.portalAgent?.portal?.portalName === "Rumah123" || v.portalAgent?.portal?.portalName === "Lamudi") && (
										<span
											style={{
												cursor: "pointer",
											}}
											onClick={() => {
												setSelectedPortalId(v.portalAgent?.portal?.portalId);
												setShowLog(true);
											}}
										>
											<Tooltip title="See Portal Logs">
												<EyeOutlined />
											</Tooltip>
										</span>
									)}
								</Space>
							</Tag>
							{showLinkPortal(v.portalListingId) ? (
								<Typography.Text style={{ color: "#8C8C8C" }}>
									{showLinkPortal(v.portalListingId)}
								</Typography.Text>
							) : (
								<NotSet />
							)}
						</Space>
						{portLists[portLists.length - 1].portalListingId !== v.portalListingId && (
							<Divider type="vertical" />
						)}
					</>
				))}
			</Space>

			<PortalSyncLogModal
				listingId={listing.listingId}
				portalId={selectedPortalId}
				title={selectedPortalId === LAMUDI_ID ? `Lamudi Portal Listing Sync Log For Listing ${listing.listingCode}` : `Rumah123 Portal Listing Sync Log For Listing ${listing.listingCode}`}
				open={showLog}
				onClose={() => {
					setShowLog(false);
					setSelectedPortalId(undefined);
				}}
			/>
		</>
	);
}
